'use strict';

var abstractMatrix = require('../abstractMatrix');
var Matrix = require('../matrix');

class BaseView extends abstractMatrix() {
    constructor(matrix, rows, columns) {
        super();
        this.matrix = matrix;
        this.rows = rows;
        this.columns = columns;
    }

    static get [Symbol.species]() {
        return Matrix.Matrix;
    }
}

module.exports = BaseView;



// WEBPACK FOOTER //
// ./node_modules/ml-pca/node_modules/ml-matrix/src/views/base.js